export default {
  data() {
    return {
      errorsDialog: false,
    };
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    completedStep: {
      type: Number,
      default: 0,
    },
    previousStep: {
      type: Number,
      default: 0,
    },
    reset: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /* Emit 'changeValid' event with the current isValid value
   to set :disabled attribute in the Stepper Next button appropriately */
    changeCurrentValidation() {
      this.$emit('changeValid', !this.getInvalid);
    },
    /* Handle errors */
    handleErrors(err) {
      const { errors } = err.response.data;
      this.serverErrors = errors;
      this.showErrorsDialog();
      this.$emit('onError');
    },
    showErrorsDialog() {
      this.errorsDialog = true;
    },
    closeErrorsDialog() {
      this.errorsDialog = false;
    },
  },
  computed: {
    /* Get isInvalid property of the form */
    getInvalid() {
      return this.$v.$invalid;
    },
    /* Get the current Stepper step */
    getCurrentStep() {
      return this.currentStep;
    },
    /* Get the current step that user tries to go next from */
    getCompletedStep() {
      return this.completedStep;
    },
    /* Get reset value to watch when it changes to True and reset the form */
    getResetForm() {
      return this.reset;
    },
    getPreviousStep() {
      return this.previousStep;
    },
  },
  watch: {
    /* Watch when in the current step the Next button is clicked
    to send form data to the server */
    getCompletedStep() {
      if (this.getCompletedStep === this.step && this.getPreviousStep === this.getCurrentStep) {
        if (this.getInvalid) {
          this.showErrorsDialog();
          if (this.$v) {
            this.$v.$touch();
          }
          this.$emit('onError');
        } else {
          this.sendFormData();
        }
      }
    },
    /* Watch when the current step value will match this step
    to change current form validation */
    getCurrentStep() {
      if (this.currentStep === this.step) {
        this.changeCurrentValidation();
      }
    },
    /* Watch the change of the valid property of the $v model
    in order to transmit it to the Stepper */
    getInvalid() {
      this.changeCurrentValidation();
    },
    /* Watch when the reset value is changed that means that the reset button was clicked
    and check if it was done in the current step
    in order to reset the current form and $v model values */
    getResetForm() {
      if (this.currentStep === this.step) {
        this.resetForm();
        this.$emit('restoreReset');
      }
    },
  },
};
